<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="06" :question="question" :comment="comment"></QuestionTitle>
        <div class="container-70">
            <DoubleButtonChoice :button1="button1" :button2="button2" v-model="result" class="mt-100px" @update:modelValue="saveAndContinue('organisationVehiculePerso', JSON.stringify(result.label), result.link)" ></DoubleButtonChoice>
            <AvancementLine percent="37.5%" class="mt-50px"></AvancementLine>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import DoubleButtonChoice from '@/components/DoubleButtonChoice.vue'
import AvancementLine from '@/components/AvancementLine.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'Est-ce que les employés.es de votre organisation utilisent les transports en commun dans le cadre de leur travail?',
            comment:'Cette catégorie inclut l\'autobus, le métro, le train et l\'avion.',
            modalActive:false,
            button1:{
                link:'./question-7',
                label:'Oui'
            },
            button2:{
                link:'./question-8',
                label:'Non'
            }
        }
    },
    components: {
        QuestionTitle,
        AvancementLine,
        DoubleButtonChoice
    },
    mixins:[utils]
}
</script>